import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_821a595f: FaireBrandEntity = {
  token: "b_821a595f",
  type: "brand",
  name: "Lovett Sundries",
  avatarUrl:
    "https://cdn.faire.com/fastly/5a48e664ebc698d763337fa0aa08eb9046d5e51bf67f3b7cb9cf9801c1d20886.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c47cd8c4404a74892e87079b4a72e314eb55cde6cf0ec467fb152507ec3164ef.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5a48e664ebc698d763337fa0aa08eb9046d5e51bf67f3b7cb9cf9801c1d20886.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c47cd8c4404a74892e87079b4a72e314eb55cde6cf0ec467fb152507ec3164ef.png",
  location: "Pittsburgh, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 61,
  isTopShop: true,
  isInsider: true,
  description:
    "Here at Lovett Sundries, we are excited about making your everyday routine special with our finely crafted apothecary stock.\nAfter asking what was in the soap we bought at the store, and not liking the answer, we started making our own extra gentle bars using old fashioned techniques and ingredients we could pronounce. Our friends and family loved our soaps and begged us to make more. That’s what got us into the sundries business. \nNow we feature a line of handcrafted soaps, grooming, and cleaning products that are carefully measured, mixed, and packaged by our own hands. We like doing things the old-fashioned way; it’s slower but more satisfying, and in the end it makes our products better and more meaningful.\nWe are a family company working out of Pittsburgh, Pennsylvania. Although we are small, we know that the ingredients, containers, and packaging we use make a big impact on the world. \nThat is why all our containers are recyclable, and almost all are made in the US.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:53.931Z",
    importedBy: "entity-db-cli",
  },
};
